import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { RECOVER_PASSWORD_REQUEST } from "../types/RequestTypes";
import { showToast } from "../../../utils/ToastEmitter";
import extractErrorMessage from "../../../helpers/extractErrorMessage";

async function recoverPassowrd(req: RECOVER_PASSWORD_REQUEST) {
  return fetcher({
    url: "users/recover/password",
    method: "POST",
    data: req,
  });
}

export default function useRecoverPasswordMutation(
  cb?: (val?: string) => void
) {
  return useMutation({
    mutationFn: recoverPassowrd,
    onSuccess: (res, req) => {
      cb?.(req?.email);
      showToast(
        "One_Time_Password_Sent",
        "Check_Inbox_Associated_With_Account"
      );
    },
    onError: (err: any) => {
      showToast(extractErrorMessage(err), "error");
    },
  });
}
